
document.addEventListener('DOMContentLoaded',function(){
  var hamburger=document.querySelector('[data-hamburger]');
  var drawer=document.querySelector('[data-drawer]');
  var closeEls=document.querySelectorAll('[data-drawer-close]');
  function openDrawer(){if(!drawer) return;drawer.classList.add('is-open');document.body.style.overflow='hidden';}
  function closeDrawer(){if(!drawer) return;drawer.classList.remove('is-open');document.body.style.overflow='';}
  if(hamburger) hamburger.addEventListener('click',openDrawer);
  closeEls.forEach(function(el){el.addEventListener('click',closeDrawer);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape') closeDrawer();});
  document.querySelectorAll('.size-pill').forEach(function(el){
    el.addEventListener('click',function(){
      var g=el.closest('.size-group'); if(g){g.querySelectorAll('.size-pill').forEach(function(s){s.classList.remove('active');});}
      el.classList.add('active');
    });
  });
  document.querySelectorAll('[data-quick-add]').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault(); e.stopPropagation();
      var id=btn.getAttribute('data-variant-id'); if(!id) return;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})}).then(function(r){if(r.ok) window.location.href='/cart';});
    });
  });
});
